import React, { useEffect, useState } from "react";
import { ModalScreen } from "../../../components/ModalScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { InputAdornment, TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../../Validators/ValSpecialCharacters";
import TodayIcon from "@mui/icons-material/Today";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";

export const ModalAutorizarFacturacionCondicionada = ({
  folio,
  setOpen,
  loader,
  setLoader,
  setState,
  state,
  upload,
  onCargarState
}) => {
  const [comentariosCondicion, setComentariosCondicion] = useState("");
  const [compromiso, setCompromiso] = useState("");
  const [documentacion, setDocumentacion] = useState([]);
  const [estatus, setEstatus] = useState({});

  const onChange = (prop, value, sbool, smensaje) => {
    setComentariosCondicion(value);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACDocumentacion/GetOtorgamientoCondicionado?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setDocumentacion(result.documentacion);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);

  const handleVencimientoChange = (event) => {
    setCompromiso(event.target.value); // Actualiza el estado del vencimiento
  };

  const otorgamientodocumento = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ACDocumentacion/AgregarDocumentoCondicionado?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDocumentacion(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const onAutorizarFacturacion = () => {
    // const fechaCompromiso = new Date(compromiso);

    const fechaActual = new Date();
    const fechaActualFormateada = formatDate(fechaActual);

    if (
      comentariosCondicion === "" ||
      comentariosCondicion === undefined ||
      comentariosCondicion === null
    ) {
      Swal.fire(
        "Autorizar facturación",
        "Favor de agregar comentarios",
        "warning"
      );
      return;
    }
    if (compromiso === "" || compromiso === undefined || compromiso === null) {
      Swal.fire(
        "Autorizar facturación",
        "Favor de agregar una fecha",
        "warning"
      );
      return;
    }
    if (compromiso < fechaActualFormateada) {
      Swal.fire(
        "Autorizar facturación",
        "La fecha de compromiso no puede ser menor a la fecha actual",
        "warning"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      comentarios: comentariosCondicion,
      fecha: compromiso,
    };
    request
      .post("SCFacturacionCondicionada", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setState({
          ...state,
          header: result.encabezado,
          detalle: result.detalle,
        });
        upload()
        setOpen(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO CONDICIONADO", JSON.stringify(error), "error");
      });
  };

  const onCerrar = () => {
    setOpen(false)
    onCargarState()
  }

  return (
    <ModalScreen close={setOpen}>
      <span className="filtro-soy-span-close" onClick={() => onCerrar()}>
        X
      </span>
      <PlantillaScreen
        titulo={"Autorización de Facturación"}
        className={"asc-modal"}
      >
        <div>
          <div>
            <TextField
              fullWidth
              size="small"
              label="Comentarios"
              className="input-comentarios-validar-condiciones"
              multiline
              rows={3}
              type="text"
              onChange={({ target }) => {
                ValSpecialCharacters(
                  "comentariosCondicion",
                  target.value,
                  onChange,
                  true,
                  500
                );
              }}
              value={comentariosCondicion}
            />
          </div>
          <div className="modal-autorizar-facturacion-condicionado-fecha-container">
            <TextField
              fullWidth
              size="small"
              label="Fecha compromiso"
              variant="outlined"
              className="cel-1"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TodayIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              type="date"
              value={compromiso}
              onChange={handleVencimientoChange} // Asigna el manejador del evento
            />
          </div>
          <div className="modal-autorizar-facturacion-condicionado-solicitar-documentacion-container-table scroll">
            <table cellSpacing={0} cellPadding={0}>
              <thead>
                <tr>
                  <th>Documento</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {documentacion.map((item) => (
                  <tr key={item.iddocumento}>
                    <td>{item.documento}</td>
                    <td>
                      {item.tiene_documentacion ? (
                        <div
                          className="otorgamiento-cancelar"
                          onClick={() =>
                            otorgamientodocumento(item.iddocumento)
                          }
                        >
                          Cancelar
                        </div>
                      ) : (
                        <div
                          className="otorgamiento-solicitar"
                          onClick={() =>
                            otorgamientodocumento(item.iddocumento)
                          }
                        >
                          Solicitar
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            className="analisis-credito-modal-mhusa-content-acept-button"
            onClick={() => {
              onAutorizarFacturacion();
            }}
          >
            {/* <CheckCircleIcon /> */}
            <div> Autorizar Facturacion</div>
          </div>
        </div>
      </PlantillaScreen>
    </ModalScreen>
  );
};
